export const toggleModalCreateContract = () => ({
  type: "TOGGLE_MODAL_CREATE_CONTRACT"
});
export const toggleModalCreateTask = () => ({
  type: "TOGGLE_MODAL_CREATE_TASK"
});
export const toggleModalWizzard = () => ({ type: "TOGGLE_MODAL_MODAL_WIZARD" });
